<template>
  <div>
    <div class="header">
      <span>工作量统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-cascader
            size="mini"
            style="width: 150px"
            v-model="orgIndex"
            :options="orgs"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            @change="selectOrg">
          </el-cascader>
        </el-form-item>
        <!--<el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>-->
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border v-loading.body="loading" stripe style="width: 100%;">
      <el-table-column
        label="序号"
        type="index"
        width="50">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="countRecord"
        label="创建病历数">
      </el-table-column>
      <el-table-column
        prop="countOperation"
        label="手术数量">
      </el-table-column>
      <el-table-column
        prop="countFollowUp"
        label="随访数量">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import moment from 'moment';
  import RecordCountService from '@/request/count/record'
  export default {
    name: "count-workload",
    data () {
      return {
        tableData: [],
        data: null,
        start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
        end: moment().endOf('day').valueOf(), // 结束时间
        dateRadio: '日',
        dateType: 'date',
        oid: null,
        loading: true,
        orgIndex: [1,2,5]
      }
    },
    props: {
      orgs: {
        type: Array,
        default() {
          return []
        }
      }
    },
    watch: {
      orgs() {
        this.init();
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        if (this.orgs.length === 0) {
          return
        }
        this.orgIndex = []
        this.getOid(this.orgs);
        this.load();
      },
      getOid(orgs) {
        if (orgs[0].children) {
          this.orgIndex.push(orgs[0].id)
          this.getOid(orgs[0].children)
        } else {
          this.orgIndex.push(orgs[0].id)
          this.oid = orgs[0].id
        }
      },
      load() {
        this.loading = true;
        RecordCountService.workload({
          oids: this.oid || null,
          start: moment(this.start).startOf('day').valueOf(),
          end: moment(this.end).endOf('day').valueOf(),
        }).then(res => {
          this.tableData = res.result || [];
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 选中科室
      selectOrg(index) {
        this.oid = index[index.length -1]
        this.load();
      },
      dateChange() {
        if (!this.start || !this.end) {
          this.$message({
            message: '开始时间或结束时间不能为空',
            type: 'warning'
          });
          return
        }
        if (this.start > this.end) {
          this.$message({
            message: '开始时间不能大于结束时间',
            type: 'warning'
          });
        }
        this.load();
      }
      /*dateRadioChange(event) {
        switch (event) {
          case '年':
            this.dateType = 'year';
            this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
            this.end =  moment().endOf('year').valueOf(); // 结束时间
            break;
          case '月':
            this.dateType = 'month';
            this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
            this.end =  moment().endOf('month').valueOf(); // 结束时间
            break;
          default:
            this.dateType = 'date';
            this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
            this.end =  moment().endOf('day').valueOf(); // 结束时间
        }
        this.dateChange();
      },*/
    }
  }
</script>

<style scoped>
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style>
